"use client";

import { useEffect, useId } from "react";

/**
 * <TweetEmbed user="OpenAI" id="1234567890" />
 */
export default function TweetEmbed({ user, id }) {
    const wid = useId();

    useEffect(() => {
        // inject once
        const ID = "twitter-wjs";
        if (!document.getElementById(ID)) {
            const s = document.createElement("script");
            s.id = ID;
            s.async = true;
            s.src = "https://platform.twitter.com/widgets.js";
            s.charset = "utf-8";
            s.referrerPolicy = "origin-when-cross-origin";
            document.body.appendChild(s);
        } else if (window.twttr?.widgets?.load) {
            window.twttr.widgets.load();
        }
    }, []);

    if (!user || !id) {
        return (
            <div className="bg-yellow-100 text-yellow-800 rounded p-3 my-4 text-sm">
                Invalid tweet props.
            </div>
        );
    }

    return (
        <blockquote id={wid} className="twitter-tweet">
            <a href={`https://x.com/${user}/status/${id}`}>Tweet</a>
        </blockquote>
    );
}
